import { useContext } from 'react';
import Button from '../../components/Button';
import CustomModal from '../../components/CustomModal';
import CustomModalHeader from '../../components/CustomModal/CustomModalHeader';
import {
    CLAIM_PERFORMANCE_FEES_PENDING,
    PERFORMANCE_FEES_CLAIMED,
} from '../../config/constants';
import appContext from '../../context/app/appContext';
import errorContext from '../../context/error/errorContext';
import modalContext from '../../context/modal/modalContext';
import { formatUSD } from '../../helpers/formats';
import useClaimablePerformanceFees from '../../hooks/web3/vault/useClaimablePerformanceFees';
import { sleep } from '../../web3/utils';

const ClaimPerformanceFeesModal: React.FC = () => {
    const { openModal, closeModal, setModalData } = useContext(modalContext);

    const { claimablePerformanceFees, updateClaimablePerformanceFees } =
        useClaimablePerformanceFees();

    const { interfaceSDK, chainConfig } = useContext(appContext);
    const { setError } = useContext(errorContext);

    const onClose = () => closeModal('claimPerformanceFeesModal');

    const claim = async () => {
        try {
            if (!interfaceSDK || !claimablePerformanceFees) return;

            setModalData((prev) => ({
                ...prev,
                message: CLAIM_PERFORMANCE_FEES_PENDING,
            }));
            openModal('waitingModal');

            const stakingContract =
                await interfaceSDK.get.getSpoolStakingContractInstance();

            const rewards = await stakingContract.getRewards(
                [chainConfig['SPOOL-DAI-LP']],
                false
            );

            const receipt = await rewards.wait();

            await sleep(3000);

            await updateClaimablePerformanceFees(claimablePerformanceFees);

            onClose();
            setModalData((prev) => ({
                ...prev,
                status: PERFORMANCE_FEES_CLAIMED,
                txHash: receipt.transactionHash,
                message: '',
            }));
            openModal('successModal');
        } catch (error) {
            setError(error);
        } finally {
            closeModal('waitingModal');
        }
    };

    return (
        <CustomModal
            modalName='claimPerformanceFeesModal'
            className='claim-performance-fees-rewards-modal'
        >
            <CustomModalHeader title='Claim All Rewards' onClose={onClose} />
            <div className='note'>
                Claims ALL your performance Fees and deposits them in your wallet.
            </div>
            <div className='details'>
                <span>Details</span>
                <div className='detail-container'>
                    <div className='name'>Claimable Performance Fees</div>
                    <div className='value'>
                        {formatUSD(claimablePerformanceFees || '0')} $SPOOL/$DAI LP
                    </div>
                </div>
            </div>
            <div className='total'>
                <div className='text'>Total to Claim:</div>
                <div className='available'>
                    <div className='claimable'>
                        {formatUSD(claimablePerformanceFees || '0')} $SPOOL/$DAI LP
                    </div>
                </div>
            </div>
            <Button onClick={claim}>Claim</Button>
        </CustomModal>
    );
};

export default ClaimPerformanceFeesModal;
